import { authenticatedRequest } from './authInterceptor';

// Configuración de la API
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://backend.teamiflow.com',
  ENDPOINTS: {
    LOGIN: process.env.REACT_APP_API_LOGIN_ENDPOINT || '/auth/login',
    REGISTER: process.env.REACT_APP_API_REGISTER_ENDPOINT || '/auth/signup',
    DASHBOARD: process.env.REACT_APP_API_DASHBOARD_ENDPOINT || '/dashboard',
    ACCOUNT: process.env.REACT_APP_API_ACCOUNT_ENDPOINT || '/account',
    REFRESH: process.env.REACT_APP_API_REFRESH_ENDPOINT || '/auth/refresh',
    CONFIRM: process.env.REACT_APP_API_CONFIRM_ENDPOINT || '/auth/confirm',
    PROJECTS: process.env.REACT_APP_API_PROJECTS_ENDPOINT || '/projects',
    PROJECT: process.env.REACT_APP_API_PROJECT_ENDPOINT || '/projects',
    CREATE_PROJECT: process.env.REACT_APP_API_CREATE_PROJECT_ENDPOINT || '/projects',
    PAYMENTS: process.env.REACT_APP_API_PAYMENTS_ENDPOINT || '/payments/charge',
    TASKS: process.env.REACT_APP_API_TASKS_ENDPOINT || '/tasks',
    TASK: process.env.REACT_APP_API_TASK_ENDPOINT || '/tasks',
    USERS: process.env.REACT_APP_API_USERS_ENDPOINT || '/users',
    USER: process.env.REACT_APP_API_USER_ENDPOINT || '/users',
    CATEGORIES: process.env.REACT_APP_API_CATEGORIES_ENDPOINT || '/categories',
    TAGS: process.env.REACT_APP_API_TAGS_ENDPOINT || '/tags',
  },
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  APP_NAME: process.env.REACT_APP_NAME || 'TeamiFlow',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  APP_URL: process.env.REACT_APP_APP_URL || 'http://localhost:3000'
};

// Función para hacer peticiones HTTP con manejo de errores
export const apiRequest = async (url, options = {}) => {
  try {
    return await authenticatedRequest(url, options);
  } catch (error) {
    console.error('API Request failed:', error);
    throw error;
  }
};

// Función para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Función específica para login (sin token)
export const loginRequest = async (url, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, { ...defaultOptions, ...options });
    
    // Verificar si la respuesta no es exitosa (códigos diferentes de 200-299)
    if (!response.ok) {
      // Intentar parsear el error del backend
      const errorData = await response.json().catch(() => ({}));
      
      // Crear mensaje de error apropiado
      let errorMessage = 'Error al iniciar sesión';
      
      // Si el código es 401 o 403, es un error de autenticación
      if (response.status === 401 || response.status === 403) {
        errorMessage = 'Usuario o contraseña inválidos';
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else {
        errorMessage = `Error del servidor: ${response.status}`;
      }
      
      // Lanzar error sin recargar la página
      throw new Error(errorMessage);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Login request failed:', error);
    // Re-lanzar el error para que sea manejado por el componente
    throw error;
  }
};
